var Language = {

	jsonPath: 'data/translations.json',

	languages: [],
	translations: {},

	language: 'es-ES',

	setConfig: function(languages, currentLanguage) {
		this.languages = languages;

		if (languages[currentLanguage]) {
			this.setLanguage(currentLanguage);
		} else {
			console.error('The current language of the configuration is not a language of the list', languages);
		}
	},

	load: function() {
		return $.getJSON(this.jsonPath, (function(json) {
			this.translations = json;
			this.setValidationMessages();
		}).bind(this)).fail(function() {
			console.error('Error loading translations.json');
		});
	},

	init: function() {
		if($('body').attr('lng-code') != this.language) {
			this.translatePage();
		}
	},

	translatePage: function(prev) {

		$('[lng-key-img]').each((function(index,element)
		{
			var tagName = $(element).prop('tagName').toLowerCase();
			var key = $(element).attr('lng-key-img');
			var lng = this.language;
			var translation = this.getTranslation(key, lng);
			switch(tagName) {
				case 'img':
					if ($(element).attr('src')) {
						$(element).attr('src', $(element).attr('src').replace(this.getTranslation(key, prev), this.getTranslation(key, lng)));
					}
					break;
				default:
					$(element).html(translation);

			}
		}).bind(this));

		$('[lng-key]').each((function(index, element) {

			var tagName = $(element).prop('tagName').toLowerCase();

			var key = $(element).attr('lng-key');
			var lng = this.language;
			var translation = this.getTranslation(key, lng);

			switch(tagName) {
				case 'input':
					$(element).attr('placeholder', translation);
					break;
				case 'img':
					if($(element).attr('alt')) {
						$(element).attr('alt', translation);
					}
					break;
				case 'a':
					if($(element).attr('title')) {
						$(element).attr('title', translation);
					}
				default:
					$(element).html(translation);
			}

		}).bind(this));

		// Date pickers translations
		DatePicker.initDatePickers();
		DateRangePicker.reinitDateRangePickers();

		// Validation messages translations
		this.setValidationMessages();

		// If exists error validations messages, revalid
		if($('form').find('label.error').length > 0) {
			$('form').find('label.error').remove();
			$('form').valid();
		}
	},

	getTranslation: function(key, language) {
		if (this.translations[key] && this.translations[key][language]) {
			return this.translations[key][language];
		} else {
			return '## missing translation ## ' + key + ' ' + language;
		}
	},

	getLanguage: function(language) {
		return this.language;
	},

	setLanguage: function(language) {

		if (this.languages[language]) {
			this.language = language;
		} else {
			console.error('You are setting an unknown code language', language, this.languages);
		}
	},

	setValidationMessages: function() {

		$.extend($.validator.messages, {
			required: this.translations['validation-message-required'][this.language],
			remote: this.translations['validation-message-remote'][this.language],
			email: this.translations['validation-message-email'][this.language],
			url: this.translations['validation-message-url'][this.language],
			date: this.translations['validation-message-date'][this.language],
			dateISO: this.translations['validation-message-dateISO'][this.language],
			number: this.translations['validation-message-number'][this.language],
			digits: this.translations['validation-message-digits'][this.language],
			creditcard: this.translations['validation-message-creditcard'][this.language],
			equalTo: this.translations['validation-message-equalTo'][this.language],
			extension: this.translations['validation-message-extension'][this.language],
			maxlength: $.validator.format(this.translations['validation-message-maxlength'][this.language]),
			minlength: $.validator.format(this.translations['validation-message-minlength'][this.language]),
			rangelength: $.validator.format(this.translations['validation-message-rangelength'][this.language]),
			range: $.validator.format(this.translations['validation-message-range'][this.language]),
			max: $.validator.format(this.translations['validation-message-max'][this.language]),
			min: $.validator.format(this.translations['validation-message-min'][this.language]),
			requireFromGroup: this.translations['validation-message-require-from-group'][this.language],
			nifES: this.translations['validation-message-nifES'][this.language],
			nieES: this.translations['validation-message-nieES'][this.language],
			cifES: this.translations['validation-message-cifES'][this.language]
		});
	}
}
